/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_ElInputs */

const en_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const es_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const de_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const zh_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const ar_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const fr_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const vi_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const sw_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const th_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const bs_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const ja_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const ko_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const pt_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const it_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const sv_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const nl_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const da_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const nb_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const fi_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const pl_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const ru_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const tr_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const hi_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const id_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const ms_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const cs_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const el_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const he_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const af_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

const hu_nav_language_el = /** @type {(inputs: Nav_Language_ElInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ελληνικά`)
};

/**
* | output |
* | --- |
* | "Ελληνικά" |
*
* @param {Nav_Language_ElInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_el = /** @type {((inputs?: Nav_Language_ElInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_ElInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_el(inputs)
	if (locale === "de") return de_nav_language_el(inputs)
	if (locale === "zh") return zh_nav_language_el(inputs)
	if (locale === "ar") return ar_nav_language_el(inputs)
	if (locale === "fr") return fr_nav_language_el(inputs)
	if (locale === "vi") return vi_nav_language_el(inputs)
	if (locale === "sw") return sw_nav_language_el(inputs)
	if (locale === "th") return th_nav_language_el(inputs)
	if (locale === "bs") return bs_nav_language_el(inputs)
	if (locale === "ja") return ja_nav_language_el(inputs)
	if (locale === "ko") return ko_nav_language_el(inputs)
	if (locale === "pt") return pt_nav_language_el(inputs)
	if (locale === "it") return it_nav_language_el(inputs)
	if (locale === "sv") return sv_nav_language_el(inputs)
	if (locale === "nl") return nl_nav_language_el(inputs)
	if (locale === "da") return da_nav_language_el(inputs)
	if (locale === "nb") return nb_nav_language_el(inputs)
	if (locale === "fi") return fi_nav_language_el(inputs)
	if (locale === "pl") return pl_nav_language_el(inputs)
	if (locale === "ru") return ru_nav_language_el(inputs)
	if (locale === "tr") return tr_nav_language_el(inputs)
	if (locale === "hi") return hi_nav_language_el(inputs)
	if (locale === "id") return id_nav_language_el(inputs)
	if (locale === "ms") return ms_nav_language_el(inputs)
	if (locale === "cs") return cs_nav_language_el(inputs)
	if (locale === "el") return el_nav_language_el(inputs)
	if (locale === "he") return he_nav_language_el(inputs)
	if (locale === "af") return af_nav_language_el(inputs)
	if (locale === "hu") return hu_nav_language_el(inputs)
	return en_nav_language_el(inputs)
});